// extracted by mini-css-extract-plugin
module.exports = {"root":"az_sX","disabled":"az_tX","edgeStart":"az_uX","edgeEnd":"az_vX","colorInherit":"az_wX","colorPrimary":"az_xX","colorSecondary":"az_yX","sizeSmall":"az_zX","label":"az_AX"};